import { compose } from 'redux';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { STORE_MAPPING_ACCESS } from 'constants/featureToggleNames';
import { setStoreNumber } from '../../actions';
import StoreMappingLoader from './StoreMappingLoader';

const mapStateToProps = ({ user: { data }, generalManagerStores: { selectedStore } }) => {
  return {
    associatePin: data?.employeeNumber,
    selectedStore: _get(selectedStore, [data?.brand, 'storeId'], null),
  };
};

const mapDispatchToProps = {
  setStoreNumber,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFeatureToggles({ isStoreMappingEnabled: STORE_MAPPING_ACCESS }),
)(StoreMappingLoader);
